import { questionPluginModule } from './di';
import { choiceQuestionFactoryModule } from '../../question-plugins/choice/di';
import { fillInQuestionFactoryModule } from '../../question-plugins/fill-in/di';
import { groupingQuestionFactoryModule } from '../../question-plugins/grouping/di';
import { hotspotQuestionFactoryModule } from '../../question-plugins/hotspot/di';
import { matchingQuestionFactoryModule } from '../../question-plugins/matching/di';
import { shortAnswerQuestionFactoryModule } from '../../question-plugins/short-answer/di';
import { scenarioQuestionFactoryModule } from '../../question-plugins/scenario/di';
import { sortingQuestionFactoryModule } from '../../question-plugins/sorting/di';

export const questionFactoryModules = [
  questionPluginModule,
  choiceQuestionFactoryModule,
  fillInQuestionFactoryModule,
  groupingQuestionFactoryModule,
  hotspotQuestionFactoryModule,
  matchingQuestionFactoryModule,
  shortAnswerQuestionFactoryModule,
  scenarioQuestionFactoryModule,
  sortingQuestionFactoryModule,
]
